import { useContext, useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import { GlobalContext } from "../../../context/GlobalContext"
import { Container, Overlay } from "./style"

export type AvisoType = 'error' | 'success' | 'warning' | 'info'

type Props = {
    text?: string
    type?: AvisoType
    durationMs?: number
}

const inferType = (text: string): AvisoType => {
    const normalized = text.toLowerCase()

    if (normalized.includes('sucesso')) return 'success'
    if (normalized.includes('expirou') || normalized.includes('unauthorized') || normalized.includes('unauthenticated')) {
        return 'warning'
    }

    return 'error'
}

export const Aviso = ({ text = '', type, durationMs = 8000 }: Props): JSX.Element | null => {
    const { setDataToast } = useContext(GlobalContext)
    const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null)
    const avisoType = type || inferType(text)

    const close = () => {
        if (hideTimer.current) clearTimeout(hideTimer.current)
        setDataToast({ show: false, text: '', type: undefined })
    }

    useEffect(() => {
        hideTimer.current = setTimeout(() => {
            setDataToast({ show: false, text: '', type: undefined })
        }, durationMs)

        return () => {
            if (hideTimer.current) clearTimeout(hideTimer.current)
        }
    }, [text, durationMs, setDataToast])

    if (typeof document === 'undefined') return null

    return createPortal(
        <Overlay>
            <Container $type={avisoType} role="alert" aria-live="assertive">
                <div className="aviso-progress" />
                <div className="aviso-content">
                    <p className="aviso-text">{text}</p>
                    <button type="button" className="aviso-close" aria-label="Fechar aviso" onClick={close}>
                        <svg viewBox="0 0 14 14" fill="none" aria-hidden="true">
                            <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>
            </Container>
        </Overlay>,
        document.body
    )
}
